import styled from 'styled-components';
import { grid } from 'styled-system';

import Box from 'relements/build/esm/ui/box';

const ContainerStyle = (props) => ({
  flexDirection: 'column',
  marginTop: props.isActiveToolExist
    ? 4 * props.theme.space.md
    : 4 * props.theme.space.sm,
  padding: props.theme.space.zero,
});
export const Container = styled(Box)(ContainerStyle);

const GridStyle = (props) => ({
  padding: props.theme.space.zero,
  marginTop: 2 * props.theme.space.sm,
  flexWrap: 'wrap',
});
export const Grid = styled(Box)(grid, GridStyle);

const ColumnStyle = (props) => ({
  padding: props.theme.space.zero,
  width: '303px',
});
export const Column = styled(Box)(ColumnStyle);
